export default __webpack_public_path__ + "static/media/Login-Page.d120d1bb.jpg";